export default {
    msg: {
        diary: 'Diary',
        help: 'Help',
        plan: 'Plan',
        note: 'Note',
        finance: 'Finance',
        loginAuth: 'Login',
        login: 'Login',
        password: 'Password',
        registration: 'Registration',
        repeatPassword: 'Repeat password',
        register: 'Registration',
        name: 'Name',
        loginName: 'Login',
        projects: 'Projects',
        add: 'Add',
        createProject: 'Create project',
        editProject: 'Edit project',
        create: 'Create',
        description: 'Description',
        tags: 'Tags',
        save: 'Save',
        toCreate: 'Create',
        actions: 'Actions',
        edit: 'Edit',
        tasks: 'Tasks',
        tasksOfProject: 'Tasks of project',
        status: 'Status',
        createTask: 'Create task',
        editTask: 'Edit task',
        notes: 'Notes',
        time: 'Time',
        type: 'Type',
        date: 'Date',
        dayWeek: 'Day of week',
        dayOfMonth: 'Day of month',
        month: 'Month',
        createNote: 'Create note',
        editNote: 'Edit note',
        createAndAddTime: 'Create and add time',
        createAndAddList: 'Create and add list',
        list: 'List',
        transactions: 'Transactions',
        accounts: 'Accounts',
        groups: 'Groups',
        today: 'Today',
        yesterday: 'Yesterday',
        lastDay: 'Last day',
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        thisMonth: 'This month',
        previousMonth: 'Previous month',
        dates: 'Dates',
        account: 'Account',
        group: 'Group',
        incomeExpenses: 'Income/Expenses',
        overallBalance: 'Overall balance',
        accountBalance: 'Account balance',
        createTransaction: 'Create transaction',
        editTransaction: 'Edit transaction',
        sum: 'Sum',
        addTransaction: 'Add transaction',
        addTransfer: 'Add transfer',
        deleteQuestion: 'Delete?',
        transfer: 'Transfer',
        createTransfer: 'Create transfer',
        fromAccount: 'From account',
        toAccount: 'To account',
        balance: 'Balance',
        currency: 'Currency',
        in: 'in',
        createAccount: 'Create account',
        editAccount: 'Edit account',
        incomeExpensesPerPeriod: 'Income/expenses per period',
        monthLimit: 'Month limit',
        createGroup: 'Create group',
        editGroup: 'Edit group',
        monthlyLimitCurrency: 'Monthly limit currency',
        thereAreOutstandingSubTasks: 'There are outstanding sub tasks',
        addSubtask: 'Add subtask',
        addDateAndTime: 'Add date and time',
        addingDateAndTime: 'Adding date and time',
        subTasks: 'Sub tasks',
        isArchive: 'Is archive',
        remove: 'Remove',
        filter: 'Filter',
        progress: 'Progress',
        yes: 'Yes',
        no: 'No',
        isDone: 'Is done',
        day: 'day',
        Day: 'Day',
        comments: 'Comments',
        addComment: 'Add comment',
        cancel: 'Cancel',
        send: 'Send',
        projectDairy: 'Project dairy',
        thereAreNoTasksInTheProjectYet: 'There are no tasks in the project yet',
        addLine: "Add line",
        feed: "Feed",
        "followTheProgressOfPeople": "Follow the progress of people",
        "subscriptions": "Subscriptions",
        "numberDaysFromStartTarget": "Number of days from the start of the target",
        "projectName": "Project name",
        "targets": "Targets",
        "total": "Total",
        "done": "Done",
        "dateExpiredNeedReconsider": "Date expired, need to reconsider the goal",
        "toDay": "To day",
        "createTarget": "Create target",
        "editTarget": "Edit target",
        "addImage": "Add image",
        "noRecords": "No records",
        "toArchive": "To archive",
        "archive?": "Archive?",
        "dateStart": "Date start",
        "dateEnd": "Date end",
        "weeklyPlan": "Weekly plan",
        "monthlyPlan": "Monthly plan",
        "project": "Project",
        "task": "Task",
        "approximateDuration": "Approximate duration",
        "hours": "Hours",
        "minutes": "Minutes",
        "oneOfFieldsMustBeFilled": "one of the fields must be filled",
        "or": "or",
        "markRelatedTask": "Mark related task",
        "start": "Start",
        "end": "End",
        "datesIntersect": "dates overlap with existing record",
        "h": "h",
        "m": "m",
        "inArchive": "In archive",
        "additionalSettings": "Additional settings",
        "parentTask": "Parent task",
        "createACopy": "Create a copy",
        "copyCreatedAndOpened": "Copy created and opened",
        "delete": "Delete",
        "recordDeleted": "Record deleted",
        "postponeForTomorrow": "Postpone for tomorrow",
        "postponedUntilTomorrow": "Postponed until tomorrow",
        "dailyReport": "Daily report",
        "addImages": "Add images",
        "language": "Language",
        "recoveryPassword": "Recovery password",
        "emailConfirmedSuccessfully": "Email confirmed successfully",
        "furtherInstructionsSentEmail": "Further instructions have been sent to email",
        "recovery": "Recovery",
        "newPassword": "New password",
        "passwordSaved": "Password saved",
        "color": "Color",
        "profile": "Profile",
        "yourPersonalData": "Your personal data",
        "email": "Email",
        "timezone": "Timezone",
        "changePassword": "Change password",
        "oldPassword": "Old password",
        "change": "Change",
        "passwordChanged": "Password changed",
        "sumFromAccount": "Sum from account",
        "sumToAccount": "Sum to account",
        "highlightingTags": "Highlighting tags",
        "curator": "Curator",
        "message": "Message",
        "pushNotification": "PUSH notification",
        "subscribe": "Subscribe",
        "subscribed": "Subscribed",
        "reminders": "Reminders",
        "remindersFromTasksForThisDay": "Reminders from tasks for this day",
        "addToDayPlan": "Add to day plan",
        "reminderAt": "Reminder at",
        "logout": "Logout",
        "planOnDay": "Plan on day",
        "week": "Week",
        "addingTask/ReportForDay": "Adding task/report for day",
        "editingTask/ReportForDay": "Editing task/report for day",
        "addingTaskForWeek": "Adding task for week",
        "editingTaskForWeek": "Editing task for week",
        "addingTaskForMonth": "Adding task for month",
        "editingTaskForMonth": "Editing task for month",
        "transferTasksToDailyPlan": "Transfer tasks to daily plan",
        "transferTasksToWeeklyPlan": "Transfer tasks to weekly plan",
        "transferTasksToMonthlyPlan": "Transfer tasks to monthly plan",
        "fromWeekly": "From weekly",
        "fromMonthly": "From monthly",
        "fromProjects": "From projects",
        "ofPlan": "plan",
        "toTasksOfProject": "To tasks of project",
        "addingTarget": "Adding target",
        "editingTarget": "Editing target",
        "income": "Income",
        "expenses": "Expenses",
        "apply": "Apply",
        "clear": "Clear",
        "close": "Close",
        "other": "Other",
        "articles": "Articles",
        "immediateTargets": "Immediate targets",
        "yearTc": "years | year | years | yeart",
        "monthTc": "months | month | months | months",
        "weekTc": "weeks | week | weeks | weeks",
        "dayTc": "days | day | days | days",
        "toTarget": "To target",
        "report": "Report",
        "projectReport": "Project report",
        "isCompleteds": "Is completed",
        "showHours": "Show hours",
        "withoutTask": "Without task",
        "filter/sorting": "Filter/Sorting",
        "sorting": "Sorting",
        "byTime": "By time",
        "byTask": "By task",
        "byAsc": "By asc",
        "byDesc": "By desc",
        "sortType": "Sort type",
        "back": "Back",
        "reportByTasks": "Report by tasks",
        "monthBudget": "Month budget",
        "oneRecord": "one record",
        "transferFrom": "Transfer from",
        "otherMonth": "other month",
        "amount": "Amount",
        "addAnotherCurrency": "Add another currency",
        "toTransfer": "Transfer",
        "foundRecords": "Found records",
        "pcs": "pcs",
        "fact": "Fact",
        "ignoreInMonthlyBudget": "Ignore in monthly budget",
        "toMonthlyBudget": "To monthly budget",
        "by": "by",
        "textColor": "Text color",
        "completeTo": "Complete to",
        "addReminder": "Add reminder",
        "publishTarget": "Publish target",
        "youHaveSuccessfullyRegistered": "You have successfully registered",
        "loginLinkHasBeenSentTo": "Login link has been sent to",
        "openMail": "Open mail",
        "tetheredDevices": "Tethered devices",
        "subscriptionEnded": "Subscription ended",
        "renewYourSubscription": "Renew your subscription",
        "subscription": "Subscription",
        "lastDayOfSubscription": "Last day of subscription",
        "noActiveSubscription": "No active subscription",
        "subscriptionPackages": "Subscription packages",
        "sale": "Sale",
        "pay": "Pay",
        "tryForFree": "Try for free",
        "chatWithCurator": "Chat with curator",
        "dayPlan": "Day plan",
        "weekPlan": "Week plan",
        "monthPlan": "Month plan",
        "planning": "Planning",
        "billing": "billing",
        "paymentError": "Payment error",
        "tryAgain": "Tru again",
        "processingPayment": "Processing payment",
        "successfulPayment": "Successful payment",
        "inDiary": "In diary",
        "everyMorningTasksForDay": "Every morning, tasks for day",
        "everyMorningComingTargets": "Every morning, coming targets",
        "connectTelegramBot": "Connect Telegram bot",
        "telegramBot": "Telegram Bot",
        "markers": "Markers",
        "toOther": "To other",
        "pageDoesNotExist": "Page does not exist",
        "toMain": "To main",
        "my": "My",
        "openTargetsChart": "Open targets chart",
        "closeTargetsChart": "Close targets chart",
        "targetDiary": "Target diary",
        "publicTarget": "Public target",
        "unaccountedBudget": "Unaccounted budget",
        "personalDataSaved": "Personal data saved",
        "mailConfirmed": "Email confirmed",
        "continue": "Continue",
        "mailConfirmationError": "Email confirmation error",
        "confirmEmail": "Confirm email",
        "linkSentToEmail": "Link sent to email",
        "confirmEmailRecoverPassword": "Confirm your email, you will need it to recover your password.",
        "errorLoginToSupport": "If you are unable to log into the service, contact technical support.",
        "perMonth": "Per month",
    },
    validation: {
        messages: {
            _default: 'not valid',
            required: 'is required',
            required_if: 'is required',
            max: 'max length {1}',
            url: 'url is not valid',
            decimal: 'not decimal',
            numeric: 'not numeric',
            min_value: 'min value {1}',
            max_value: 'max value {1}',
            char_name: 'available chars: a-z A-Z 0-9 - _ .',
            repeat_password: 'passwords do not match',
            date_order: 'end date must be after start date',
            datetime_order: 'end date must be after start date',
            datetime_both: 'fill both fields',
            min: 'min length {1}',
            uniq_currency_id: 'cannot select same currencies'
        }
    },
    $vuetify: {
        dataTable: {
            itemsPerPageText: 'Rows per page',
            ariaLabel: {
                sortNone: 'Sort none',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending',
                activateAscending: 'Activate to sort ascending.',
                activateDescending: 'Activate to sort descending.'
            }
        },
        dataFooter: {
            pageText: '{0}-{1} of {2}',
            itemsPerPageAll: 'All',
            prevPage: 'Prev page',
            nextPage: 'Next page'
        },
        dataIterator: {
            loadingText: 'Loading...'
        },
        noDataText: 'No data',
        datePicker: {
            itemsSelected: '{0} selected'
        }
    },
    txt: {
        project: {
            recordPlans: 'All plans must be recorded. Do not keep them in your head',
            projectDairy: 'Keep a goal diary. You can publish this goal diary, and other users can study it and comment.'
        },
        target: {
            recordTargets: 'Write down your goals. So you will see your vector of movement.'
        },
        note: {
            desc: 'Notes and lists are always at hand'
        },
        finance: {
            desc: 'Planning and accounting finance',
            infoSum: 'The total does not include transfers'
        }
    },
    status: {
        new: 'New',
        in_work: 'In work',
        done: 'Done'
    },
    timeType: {
        one: 'Once',
        every_day: 'Every day',
        every_week: 'Every week',
        every_month: 'Every month',
        every_year: 'Every year'
    },
    dayOfWeek: {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        7: 'Sunday'
    },
    month: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December'
    },
    monthName: {
        "January": "january",
        "February": "february",
        "March": "march",
        "April": "april",
        "May": "may",
        "June": "june",
        "July": "july",
        "August": "august",
        "September": "september",
        "October": "october",
        "November": "november",
        "December": "december",
    },
    monthShort: {
        "January": "jan",
        "February": "feb",
        "March": "mar",
        "April": "apr",
        "May": "may",
        "June": "jun",
        "July": "jul",
        "August": "aug",
        "September": "sep",
        "October": "oct",
        "November": "nov",
        "December": "dec",
    },
    monthNameNum: {
        "January": "january",
        "February": "february",
        "March": "march",
        "April": "april",
        "May": "may",
        "June": "june",
        "July": "july",
        "August": "august",
        "September": "september",
        "October": "october",
        "November": "november",
        "December": "december",
    },
    week: {
        "Monday": "monday",
        "Tuesday": "tuesday",
        "Wednesday": "wednesday",
        "Thursday": "thursday",
        "Friday": "friday",
        "Saturday": "saturday",
        "Sunday": "sunday"
    },
    typeTransaction: {
        income: 'income',
        expenses: 'expenses',
        transfer: 'transfer'
    },
    filter: {
        is_done: 'Is done',
        is_archive: 'Is archive',
        tags: 'Markers',
        is_follow: 'Subscriptions',
        "type": "Type",
        "date_start": "Date from",
        "date_end": "Date to",
        "account": "Account",
        "group": "Group",
        "is_completed": "Is completed",
        "show_hours": "Show hours",
        "sort_by": "Sorting",
        "sort_type": "Sort type",
        "month": "Month"
    },
    "apiError": {
        "wrongPassword": "wrong password",
        "invalidEmailOrPassword": "invalid email or password",
        "loginHasAlready": "this login is busy",
        "emailHasAlready": "user is already registered with this Email"
    }
}
